export default __webpack_public_path__ + "static/media/location.ee0896f1.svg";